module.exports = __webpack_public_path__ + "img/十门控制器.5e97bd26.png";